import { z } from 'zod'

export type TreeOpcUaNode = OpcUaNode & {
  path: string[]
  childCount: {
    children: number
    subscribedChildren: number
  }
}

export const StoredFileUrlsSchema = z.object({
  nodes: z.string().optional(),
  references: z.string().optional(),
})

export type StoredFileUrls = z.infer<typeof StoredFileUrlsSchema>

export type OpcUaNode = {
  addedAt: string
  browseName: string
  class: OpcUaNodeClass
  dataType?: string
  dataTypeId?: string
  description: string
  displayName?: string
  extendedNodeId: string
  forwardReferences: string[]
  id: string
  isSubscribable: boolean
  lastBrowseError?: string
  lastBrowsedAt?: string
  lastSeenAt: string
  nodeId: string
  typeDefinition?: string
  typeDefinitionId: string
  valueRank?: number
}

export enum OpcUaNodeClass {
  DataType = 'DATA_TYPE',
  Method = 'METHOD',
  Object = 'OBJECT',
  ObjectType = 'OBJECT_TYPE',
  ReferenceType = 'REFERENCE_TYPE',
  Variable = 'VARIABLE',
  VariableType = 'VARIABLE_TYPE',
  View = 'VIEW',
}

export type OpcUaNodeWithPath = OpcUaNode & {
  path?: string[]
}
